import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import 'vant/lib/index.css';
// import VConsole from 'vconsole';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
// new VConsole();
